import { render, staticRenderFns } from "./ResourceMediaTab.vue?vue&type=template&id=36bd083f&scoped=true"
import script from "./ResourceMediaTab.vue?vue&type=script&lang=js"
export * from "./ResourceMediaTab.vue?vue&type=script&lang=js"
import style0 from "./ResourceMediaTab.vue?vue&type=style&index=0&id=36bd083f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd083f",
  null
  
)

export default component.exports